import { ContextualContentCombinedProps } from './types';

const usePresenter = (props: ContextualContentCombinedProps): ContextualContentCombinedProps => {
  return props;
};

export default usePresenter;
